module.exports = __webpack_public_path__ + "img/case_hotel.066fcdda.png";